var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "store_review_box" }, [
    _c(
      "div",
      { staticClass: "store_review_title" },
      [_c("CustomBreadcrumb")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "store-info" },
      [
        _c("div", { staticClass: "store-info-review" }, [
          _vm._v("Store Review")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "store-info-title" }, [_vm._v("Store Info")]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "storeInfo",
            staticClass: "store-info-form",
            attrs: { model: _vm.storeInfo }
          },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Business Email", prop: "email" } },
                      [
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.storeInfo.email,
                            callback: function($$v) {
                              _vm.$set(_vm.storeInfo, "email", $$v)
                            },
                            expression: "storeInfo.email"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { label: "phone", prop: "phone" }
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.storeInfo.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.storeInfo, "phone", $$v)
                            },
                            expression: "storeInfo.phone"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "Store Type", prop: "onlineShopType" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { disabled: "", placeholder: "Store Type" },
                            model: {
                              value: _vm.storeInfo.onlineShopType,
                              callback: function($$v) {
                                _vm.$set(_vm.storeInfo, "onlineShopType", $$v)
                              },
                              expression: "storeInfo.onlineShopType"
                            }
                          },
                          _vm._l(_vm.storeType, function(item, index) {
                            return _c("el-option", {
                              key: item.textTitle,
                              attrs: { label: item.textTitle, value: index }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { label: "Store Name", prop: "storeName" }
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.storeInfo.storeName,
                            callback: function($$v) {
                              _vm.$set(_vm.storeInfo, "storeName", $$v)
                            },
                            expression: "storeInfo.storeName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "Store Address", prop: "storeAddress" } },
              [
                _c("el-input", {
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.detailAddress,
                    callback: function($$v) {
                      _vm.detailAddress = $$v
                    },
                    expression: "detailAddress"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: { label: "Store Contact Name", prop: "storeContactName" }
              },
              [
                _c("el-input", {
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.storeInfo.storeContactName,
                    callback: function($$v) {
                      _vm.$set(_vm.storeInfo, "storeContactName", $$v)
                    },
                    expression: "storeInfo.storeContactName"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.brandTips.tips
          ? _c("div", { staticClass: "brand-tips" }, [
              _c("div", { staticClass: "brand-tips-img-border" }, [
                _c("img", {
                  staticClass: "brand-tips-img",
                  attrs: { src: _vm.brandTips.brandImg }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "brand-tips-main" }, [
                _c("div", { staticClass: "brand-tips-title" }, [
                  _vm._v(_vm._s(_vm.brandTips.brandName))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "brand-tips-text" }, [
                  _vm._v("Expected Ordering Store Types:")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "brand-tips-content" }, [
                  _vm._v(_vm._s(_vm.brandTips.tips))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "inp-list" },
          [
            _c("div", { staticClass: "inp-item" }, [
              _c("div", { staticClass: "inp-item-title" }, [
                _vm._v(" Store image")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inp-item-cont inp-item-cont3" }, [
                _c("p", { staticClass: "upload-tips-text" }, [
                  _vm._v(
                    "\n            Exterior storefront image (displaying storefront logo and overallappearance) (.jpeg/.png/.jpg)\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "simple-head" },
                  _vm._l(_vm.storeInfo.exteriorStoreImageList, function(
                    item,
                    index
                  ) {
                    return _c("img", {
                      key: index,
                      staticClass: "store-image",
                      attrs: { src: item },
                      on: {
                        click: function($event) {
                          return _vm.handlePictureCardPreviewUrl(item)
                        }
                      }
                    })
                  }),
                  0
                ),
                _vm._v(" "),
                _c("p", { staticClass: "upload-tips-text upload-tips-text2" }, [
                  _vm._v(
                    "\n            Interior store images (interior panoramic views) 2-5 Image (.jpeg/.png/.jpg)\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "simple-head" },
                  _vm._l(_vm.storeInfo.interiorStoreImageList, function(
                    item,
                    index
                  ) {
                    return _c("img", {
                      key: index,
                      staticClass: "store-image",
                      attrs: { src: item },
                      on: {
                        click: function($event) {
                          return _vm.handlePictureCardPreviewUrl(item)
                        }
                      }
                    })
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "application-title" }, [
              _vm._v(
                "Please provide a brief introduction of the reason for your application"
              )
            ]),
            _vm._v(" "),
            _c("el-input", {
              attrs: {
                disabled: "",
                maxlength: "200",
                "show-word-limit": "",
                type: "textarea"
              },
              model: {
                value: _vm.storeInfo.reason,
                callback: function($$v) {
                  _vm.$set(_vm.storeInfo, "reason", $$v)
                },
                expression: "storeInfo.reason"
              }
            }),
            _vm._v(" "),
            _vm.isOperation
              ? [
                  _c(
                    "div",
                    { staticClass: "application-title google-maps-title" },
                    [
                      _c("div", [
                        _vm._v("\n              Google Maps\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v("\n                Sales Rep/SR: "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.storeInfo.saleSdr
                                ? _vm.storeInfo.saleSdr
                                : "NULL"
                            )
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    on: { blur: _vm.changeGoogleMapUrl },
                    model: {
                      value: _vm.storeInfo.googleMapUrl,
                      callback: function($$v) {
                        _vm.$set(_vm.storeInfo, "googleMapUrl", $$v)
                      },
                      expression: "storeInfo.googleMapUrl"
                    }
                  }),
                  _vm._v(" "),
                  _vm.mapsIncorrectFlag
                    ? _c("div", { staticClass: "error-tips error-googleurl" }, [
                        _vm._v(
                          "\n           " +
                            _vm._s(_vm.mapsIncorrectTips) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            !_vm.mapsIncorrectFlag
              ? _c("div", { staticClass: "application-title store-report" }, [
                  _c("span", [_vm._v("Store Report")]),
                  _vm._v(" Check the report for detailed store data\n      ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "store-report-btn",
                on: { click: _vm.gotoReport }
              },
              [_vm._v("\n          Open Report\n      ")]
            )
          ],
          2
        ),
        _vm._v(" "),
        !_vm.isOperation && _vm.storeInfo.auditStatus === 1
          ? _c("div", { staticClass: "action" }, [
              _c(
                "div",
                { staticClass: "pass-button", on: { click: _vm.approved } },
                [_vm._v("Approved")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "reject-button", on: { click: _vm.reject } },
                [_vm._v("Adudit Reject")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isOperation && _vm.storeInfo.brandReviewStatus === 1
          ? _c("div", { staticClass: "action" }, [
              _c(
                "div",
                { staticClass: "pass-button", on: { click: _vm.approved } },
                [_vm._v("运营审核通过")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "reject-button", on: { click: _vm.reject } },
                [_vm._v("运营审核拒绝")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isOperation && _vm.storeInfo.auditStatus === 3
          ? _c("div", { staticClass: "review-reject" }, [
              _c("div", { staticClass: "review-reject-title" }, [
                _vm._v("Audit Rejected")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "review-reject-text" },
                [
                  _c("OrderRejectReason", {
                    attrs: {
                      orderRejectReason: _vm.auditReason,
                      title: "Reason for Rejection: "
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isOperation && _vm.storeInfo.brandReviewStatus === 3
          ? _c("div", { staticClass: "review-reject" }, [
              _c("div", { staticClass: "review-reject-title" }, [
                _vm._v("Audit Rejected")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "review-reject-text" },
                [
                  _c("OrderRejectReason", {
                    attrs: {
                      orderRejectReason: _vm.auditReason,
                      title: "Reason for Rejection: "
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: { visible: _vm.dialogVisible, id: "el-dialog-img" },
            on: {
              "update:visible": function($event) {
                _vm.dialogVisible = $event
              }
            }
          },
          [
            _c("img", {
              staticStyle: {
                width: "100%",
                height: "100%",
                "object-fit": "contain"
              },
              attrs: { src: _vm.dialogImageUrl, alt: "" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.reviewDialogVisible,
              "show-close": false,
              "close-on-click-modal": false,
              "close-on-press-escape": false
            },
            on: {
              "update:visible": function($event) {
                _vm.reviewDialogVisible = $event
              }
            }
          },
          [
            _c("div", { staticClass: "review-dialog-border" }, [
              _c(
                "div",
                { staticClass: "review-dialog-back", on: { click: _vm.back } },
                [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("Back")]
              ),
              _vm._v(" "),
              _vm.reviewType === 1
                ? _c("div", { staticClass: "review-dialog-pass" }, [
                    _c("div", { staticClass: "review-dialog-tips" }, [
                      _vm._v("Are you sure you have passed the review?")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-dialog-action" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticClass: "review-dialog-cancel",
                          on: { click: _vm.cancle }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticClass: "review-dialog-confirm",
                          on: { click: _vm.confirm }
                        },
                        [_vm._v("Confirm")]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.reviewType === 0
                ? _c("div", { staticClass: "review-dialog-reject" }, [
                    _c("div", { staticClass: "review-dialog-tips" }, [
                      _vm._v("Reason for rejection"),
                      _c("span", [_vm._v("Select up to 5 reasons.")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-dialog-desc" }, [
                      _vm._v(_vm._s(_vm.rejectionDesc))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "review-dialog-reason-list" },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            attrs: { max: 5 },
                            on: { change: _vm.changeRejectReasonCheckBox },
                            model: {
                              value: _vm.selectedRejectReasonList,
                              callback: function($$v) {
                                _vm.selectedRejectReasonList = $$v
                              },
                              expression: "selectedRejectReasonList"
                            }
                          },
                          _vm._l(_vm.rejectReasonList, function(
                            rejectReason,
                            index
                          ) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c("el-checkbox", {
                                  attrs: { label: rejectReason }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "el-checkbox-group",
                          {
                            on: { change: _vm.changeRejectReasonOther },
                            model: {
                              value: _vm.otherList,
                              callback: function($$v) {
                                _vm.otherList = $$v
                              },
                              expression: "otherList"
                            }
                          },
                          _vm._l(_vm.rejectReasonOtherList, function(
                            rejectReasonOther,
                            index
                          ) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c("el-checkbox", {
                                  attrs: { label: rejectReasonOther }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.isShowOtherTips
                          ? _c(
                              "div",
                              {
                                staticClass: "review-dialog-reason-other-tips"
                              },
                              [
                                _vm._v(
                                  "If the reasons mentioned above do not apply, "
                                ),
                                _c("span", [
                                  _vm._v("please contact the ShopVidi team")
                                ]),
                                _vm._v(" for confirmation. "),
                                _c("span", [
                                  _vm._v(
                                    "Please refrain from submitting the rejection review temporarily."
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showSelectRejectReasonError
                          ? _c("div", { staticClass: "reject-reason-tips" }, [
                              _vm._v("Please selected reason for rejection")
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-dialog-reject-tips" }, [
                      _c("span", [_vm._v("Friendly Reminder:")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.rejectionTips))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-dialog-action" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticClass: "review-dialog-cancel",
                          on: { click: _vm.cancle }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticClass: "review-dialog-confirm",
                          on: { click: _vm.confirm }
                        },
                        [_vm._v("Confirm")]
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98bbb42e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98bbb42e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/store-review.vue
// module id = 6CGB
// module chunks = 2